import { PropsWithChildren } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';
import { MotionSecondaryHeaderLogoWrapper } from '../MotionSecondaryHeaderLogoWrapper/MotionSecondaryHeaderLogoWrapper';

interface MotionPortfolioHeaderLogoProps extends PropsWithChildren {
  className?: string;
}

export const MotionPortfolioHeaderLogo = ({
  className,
  children,
  ...props
}: MotionPortfolioHeaderLogoProps) => {
  return (
    <MotionSecondaryHeaderLogoWrapper
      {...props}
      className={className}
      initial={{
        opacity: 0,
        scale: 0,
      }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: ANIMATION_CONFIG.portfolioHeader.logo.duration,
        delay: ANIMATION_CONFIG.portfolioHeader.logo.delay,
        type: 'spring',
      }}
    >
      {children}
    </MotionSecondaryHeaderLogoWrapper>
  );
};